/**
 * Collection/article favourite heart (#145, epic #25 slice 2): initial
 * active state is server-rendered in Liquid from the $app/favourites
 * customer metafield, and writes round-trip through the app proxy via
 * window.BAO.wishlist.addFavourite/removeFavourite (bao-head-wishlist).
 * No Bearer token — the proxy identifies the customer from Shopify's
 * signed request (ADR-0005/0013); logged-out is a seeded flag.
 *
 * The seeded favourites array is the client-side source of truth: it only
 * changes when a write succeeds, so the optimistic class toggle below
 * self-corrects on failure when updateFavourites re-announces the state.
 */
class FavouritesHeart extends window.BAO.CustomElement({
  SuperClass: HTMLButtonElement,
}) {
  static requiredAttributes () {
    return ['data-type', 'data-handle']
  }

  connectedCallback () {
    super.connectedCallback()

    this.locked = false

    this.setActiveState()
  }

  setupListeners () {
    super.setupListeners()

    this.onHeartClicked = this.onHeartClicked.bind(this)

    this.listeners.add(this, 'click', this.onHeartClicked)

    document.addEventListener('wishlist:favouritesUpdated', () => {
      this.setActiveState()
    })
  }

  setActiveState () {
    this.classList.remove('wlt-Heart-active')
    if (this.active) {
      this.classList.add('wlt-Heart-active')
    }
  }

  async onHeartClicked () {
    if (!window.BAO.wishlist.loggedIn) {
      window.BAO.wishlist.redirectToLogin()
      return
    }

    if (this.locked) return

    this.locked = true

    try {
      if (this.active) {
        this.removeActiveClass()
        await window.BAO.wishlist.removeFavourite(this.record.handle)
      } else {
        this.addActiveClass()
        await window.BAO.wishlist.addFavourite(this.type, this.handle)
      }
    } catch (error) {
      console.error('favourites-heart toggle failed', error)
    } finally {
      window.BAO.wishlist.updateFavourites()

      this.locked = false
    }
  }

  addActiveClass () {
    this.classList.add('wlt-Heart-active')
  }

  removeActiveClass () {
    this.classList.remove('wlt-Heart-active')
  }

  get type () {
    return this.dataset?.type
  }

  get handle () {
    return this.dataset?.handle
  }

  get active () {
    return Boolean(this.record)
  }

  get record () {
    const records = window.BAO.wishlist.favourites || []

    return records.find(r => r.target === this.handle)
  }
}

customElements.define('favourites-heart', FavouritesHeart, {
  extends: 'button',
})
